window.fbAsyncInit = function() {
  var appId = typeof gon !== 'undefined' && gon.facebook_id
  if (!appId) {
    console.warn('[Yula] Facebook app id missing (gon.facebook_id). Set FACEBOOK_APP_ID for Facebook login.')
    document.dispatchEvent(new CustomEvent('fb-sdk-unavailable'))
    return
  }

  FB.init({
    appId: appId,
    cookie: true,
    xfbml: true,
    version: 'v16.0'
  })

  FB.AppEvents.logPageView()
  // XFBML in the body may have been parsed before init in some cases; ensure plugins are wired.
  FB.XFBML.parse()

  window.fbSdkReady = true
  document.dispatchEvent(new CustomEvent('fb-sdk-ready'))
};

// Semicolon required: without it, `(function...` is parsed as calling the function above (ASI).
(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

document.addEventListener("DOMContentLoaded", function(_event) { 
  window.YFBLogin = (_uu, _aa, _bb, _cc) => {
    console.log('On')
  }
});